import {
  authReq
} from '@/utils/http'

const getOrders = (page, pageSize = 10, sort = '', condition = {}) => {
  return authReq.get('/api/v1/bill', {
    'page_size': pageSize,
    page,
    sort,
    ...condition
  }, 60000)
}

export default {
  getOrders
}



// WEBPACK FOOTER //
// ./src/api/billApi.js